import * as React from 'react';

/** Material UI Packages. */
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';

/** Internal Components. */
import CustomDetailPanelToggle from 'shared/ui/CustomDetailPanelToggle';

import { RateManagementDef } from './RateManagementDef';
import { rateManagementCellTypographySx } from './rateManagementShared';

const rateManagementTogglePanelSx = {
    ...rateManagementCellTypographySx,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
};

export function getRateManagementGridColumns() {
    return [
        {
            ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
            minWidth: 48,
            width: 48,
            maxWidth: 48,
            flex: 0,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <CustomDetailPanelToggle
                    id={params.id}
                    size="small"
                    component="div"
                    sx={rateManagementTogglePanelSx}
                />
            ),
        },
        ...RateManagementDef,
        {
            field: '_rate_search',
            headerName: '',
            sortable: false,
            filterable: true,
            disableExport: true,
            disableColumnMenu: true,
            disableReorder: true,
            resizable: false,
            valueGetter: (_value, row) => {
                if (!Array.isArray(row?.il_rate)) return '';
                return row.il_rate
                    .map((r) => [r.il_rate_type_id, r.rate, r.note].filter(Boolean).join(' '))
                    .join(' ');
            },
        },
        /** QuickFilter 전용: `row._quickSearch_`는 `attachRateManagementQuickSearchField`에서 채움. */
        {
            field: '_quickSearch_',
            headerName: '',
            width: 0,
            minWidth: 0,
            maxWidth: 0,
            sortable: false,
            filterable: true,
            disableExport: true,
            disableColumnMenu: true,
            disableReorder: true,
            resizable: false,
            renderCell: () => null,
        },
    ];
}
